import axios from 'axios';

// Normalize base URL and ensure it targets v1 API
const RAW_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5002/';
const NORMALIZED_BASE = RAW_BASE_URL.endsWith('/') ? RAW_BASE_URL : `${RAW_BASE_URL}/`;
const API_BASE_V1 = NORMALIZED_BASE.includes('/v1/') ? NORMALIZED_BASE : `${NORMALIZED_BASE}v1/`;

function resolveToken(explicitToken) {
  return explicitToken || (typeof localStorage !== 'undefined' ? localStorage.getItem('authToken') : undefined);
}

function authHeaders(explicitToken) {
  const token = resolveToken(explicitToken);
  return token
    ? {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        accept: 'application/json',
      }
    : {
        'Content-Type': 'application/json',
        accept: 'application/json',
      };
}

// Zoho CRM Configuration APIs
export const saveZohoConfig = async (config, token) => {
  try {
    const response = await axios.post(`${API_BASE_V1}zoho-crm/config`, config, {
      headers: authHeaders(token),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateZohoConfig = async (config, token) => {
  try {
    const response = await axios.put(`${API_BASE_V1}zoho-crm/config`, config, {
      headers: authHeaders(token),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getZohoConfig = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_V1}zoho-crm/config`, {
      headers: authHeaders(token),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const testZohoConnection = async (token) => {
  try {
    const response = await axios.post(`${API_BASE_V1}zoho-crm/test-connection`, {}, {
      headers: authHeaders(token),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLeadsCount = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_V1}zoho-crm/leads/count`, {
      headers: authHeaders(token),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// KPI Zoho Integration APIs
export const syncKpiWithZoho = async (kpiId, token) => {
  try {
    const response = await axios.post(`${API_BASE_V1}kpis/${kpiId}/zoho-sync`, {}, {
      headers: authHeaders(token),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const configureKpiZohoMapping = async (kpiId, mapping, token) => {
  try {
    const response = await axios.put(`${API_BASE_V1}kpis/${kpiId}/zoho-mapping`, mapping, {
      headers: authHeaders(token),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getKpiZohoMapping = async (kpiId, token) => {
  try {
    const response = await axios.get(`${API_BASE_V1}kpis/${kpiId}/zoho-mapping`, {
      headers: authHeaders(token),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getKpiSyncHistory = async (kpiId, token) => {
  try {
    const response = await axios.get(`${API_BASE_V1}kpis/${kpiId}/sync-history`, {
      headers: authHeaders(token),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};